import { Col, Container, Row } from "react-bootstrap";

const Intro = () => {
  return (
    <>
      <Container fluid className="intro_top text-center pt-5 pb-md-3 pb-4 m-0">
        <Row className="m-0">
          <Col className="m-0 ">
            <h1 className="text-md-center text-start">La pick-up más potente fabricada en Sudamérica</h1>
            <h2 className="text-md-center text-start">
              Se destaca por sus impresionantes líneas, manteniendo las características distintivas de las RAM.<br></br>
              <b style={{ fontWeight: 900 }}>
                La carrocería es nueva, con proporciones "musculosas" y una identidad específica para cada versión.
              </b>
            </h2>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Intro;
